<template>
  <div style="display: inline-block">

    <b-modal id="eSimInvalidateModal" size="md" centered class="bg-light text-black" title="Confirmation">
      <p class="p-0 m-0">
        You are about to <mark>INVALIDATE</mark> this profile.
        <br/>This operation CANNOT be UNDONE.
      </p>
      <template #modal-footer="{cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()"> Cancel</b-button>
        <b-button size="sm" variant="danger" @click="invalidate()"> Invalidate</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import eSimDashboardService from "@/common/api-services/esim-dashboard-service";
import authService from "@/common/api-services/auth-service";
import Toast from "./Toast.vue";

export default {
  name: "EsimInvalidateModal",
  components: {Toast},
  props: {
    iccid: String,
  },
  methods: {
    invalidate() {
      this.$bvModal.hide("eSimInvalidateModal");

      eSimDashboardService.esim_invalidate(this.iccid).then(res => {
        if (!res) throw Error('No response from server.');
        let status = res.data.header.functionExecutionStatus.status;
        authService.setActivityLog('ESIM:esim_invalidate ', status + ': ' + this.iccid, 0);
        if (status === 'Failed') {
          let message = res.data.header.functionExecutionStatus.statusCodeData.subjectIdentifier;
          throw Error('Invalidate failed with message: ' + status + ' for ' + message);
        } else {
          this.showToast("ESIM Invalidate was successful: "+this.iccid, "success");
        }
      }).catch(err => {
        authService.setActivityLog("ESIM:esim_invalidate FAILED: "+this.iccid, JSON.stringify(err), 1);
        this.showToast("ESIM Invalidate failed: "+this.iccid, "error");
      });
      this.$root.$emit("esimProfileReloadPage");
    },

    showToast(message, variant = "error") {
      //setup for alert
      this.$toast({
        component: Toast,
        props: {
          description: message,
        },
      },{
        type: variant,
      });
    },

  },
};
</script>
